var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_req",style:(`width: ${_vm.width}px; height: ${_vm.width}px`)},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'exclamation-circle']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }